var sep = require('path').sep;

module.exports = require(__dirname + '' + sep + 'lib' + sep + 'taffy').taffy;